module.exports = __webpack_public_path__ + "img/music_018.0361e97c.png";